/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createReducer, on } from '@ngrx/store';

import { Cluster } from '@core/models';
import { ClusterActions } from '@settings/store/actions';
export const CLUSTERS_FEATURE_KEY = 'clusters';

export interface ClusterState {
  clusters: Cluster[] | null;
  isLoading: boolean;
  isUpdating: boolean;
}

const initialState: ClusterState = {
  clusters: null,
  isLoading: false,
  isUpdating: false,
};

export const clusterReducer = createReducer(
  initialState,
  on(ClusterActions.loadClusters, (state) => ({ ...state, isLoading: true })),
  on(ClusterActions.updateCluster, ClusterActions.addCluster, (state) => ({ ...state, isUpdating: true })),

  on(ClusterActions.loadClustersSuccess, (state, { clusters }) => ({ ...state, clusters, isLoading: false })),

  on(ClusterActions.addClusterSuccess, (state, { cluster }) => ({
    ...state,
    clusters: [...(state.clusters || []), cluster].map((c) => ({
      ...cluster,
      selected: cluster.selected ? c.id === cluster.id : c.selected,
    })),
    isUpdating: false,
  })),

  on(ClusterActions.updateClusterSuccess, (state, { cluster }) => ({
    ...state,
    clusters:
      state.clusters &&
      state.clusters.map((c) =>
        c.id === cluster.id ? cluster : { ...c, selected: cluster.selected ? false : c.selected }
      ),
    isUpdating: false,
  })),
  on(
    ClusterActions.loadClustersFailure,
    ClusterActions.updateClusterFailure,
    ClusterActions.addClusterFailure,
    (state) => ({
      ...state,
      isLoading: false,
      isUpdating: false,
    })
  )
);
